import {
  ADD_BENEFITS,
  FETCHING_BENEFITS,
  FETCHED_BENEFITS,
  CLEAR_ALL,
} from '../constants';

interface BenefitsState {
  list: Record<string, any[]>;   // keyed by state name, e.g. { 'California': [...] }
  fetched: Record<string, boolean>;
  fetching: boolean;
}

const initialState: BenefitsState = {
  list: {},
  fetched: {},
  fetching: false,
};

const benefitsReducer = (
  state = initialState,
  { type, payload }: { type: string; payload?: any }
): BenefitsState => {
  switch (type) {
    case FETCHING_BENEFITS:
      return { ...state, fetching: Boolean(payload) };
    case ADD_BENEFITS:
      return {
        ...state,
        list: { ...state.list, [payload.state]: payload.list },
      };
    case FETCHED_BENEFITS:
      return {
        ...state,
        fetched: { ...state.fetched, [payload.state]: true },
      };
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default benefitsReducer;
